import { combineReducers } from "redux";
import authentication from "./Authentication";
import analysis from "./Analysis";
import ai from "./AI";
import interactions from "./Interactions";
import adminUser from "./AdminUser";
import forms from "./Forms";
import messaging from "./Messaging";
import knowledgeBaseBuilder from "./KnowledgeBaseBuilder";
import apiKeys from "./APIKeys";
import calls from "./Calls";

export default combineReducers({
  authentication,
  analysis,
  ai,
  interactions,
  adminUser,
  forms,
  messaging,
  knowledgeBaseBuilder,
  apiKeys,
  calls,
});
